import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BetaContext = createContext({ betaMode: false, ready: false, refresh: () => {} });

export function BetaProvider({ children }) {
  const [betaMode, setBetaMode] = useState(false);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(() => {
    axios.get(`${API}/settings/public`)
      .then(r => setBetaMode(!!r.data?.beta_mode))
      .catch(() => setBetaMode(false))
      .finally(() => setReady(true));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BetaContext.Provider value={{ betaMode, ready, refresh }}>
      {children}
    </BetaContext.Provider>
  );
}

export function useBeta() { return useContext(BetaContext); }
